module.exports = __webpack_public_path__ + "static/stone_of_good_luck-420851aec3165fb9a53763348dd9a7ae.jpeg";